import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReactiveComponent } from '@schenck/rotec-components';
import { getMachineTaskModalInfos, TaskModalService } from 'src/components';
import { MachineHistoryModalService } from './machine-history-modal.service';
import { HistoryModalComponent } from '../../../components/task-modal/history-modal/history-modal.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'ma-machine-history-modal',
  templateUrl: './machine-history-modal.component.html',
  styleUrls: ['./machine-history-modal.component.less'],
  providers: [
    MachineHistoryModalService,
    { provide: TaskModalService, useExisting: MachineHistoryModalService },
  ],
  imports: [HistoryModalComponent, AsyncPipe],
})
export class MachineHistoryModalComponent extends ReactiveComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translate = inject(TranslateService);
  public taskModalService = inject(MachineHistoryModalService);

  public state = this.connect(
    getMachineTaskModalInfos(
      this.taskModalService.task$,
      this.taskModalService.machine$,
      this.taskModalService.plant$,
      this.translate
    ),
    this.cdr
  );

  constructor() {
    super();
  }
}
